// extracted by mini-css-extract-plugin
export default {"placeholder":"image_placeholder__1VHr1","feature":"image_feature__U3eDb","square":"image_square__25V-j","poster":"image_poster__1zFgB","standard":"image_standard__2YDv8"};